import React from 'react';
import { PortfolioInfoLink, ProjectLink } from '../../../links/index.jsx';
import DateRange from './DateRange.jsx';
import InitiativeCounts from './InitiativeCounts.jsx';
import InitiativeRows from './InitiativeRows.jsx';
import ProjectCompletion from './ProjectCompletion.jsx';
import { RATINGS } from '../../../../lib/schema.js';
import RatingLabel from '../../../RatingLabel.jsx';
import { getOrgTermsContent } from '../../../../content/utils.js';
import VerticalSeparator from '../../../VerticalSeparator.jsx';

class ProjectRow extends React.Component {
  state = {
    initiativesHidden: true,
  };

  toggleInitiatives = (e) => {
    e.preventDefault();
    this.setState(({ initiativesHidden }) => ({
      initiativesHidden: !initiativesHidden,
    }));
  };

  render() {
    const { project, participantType, hasParentPortfolios } = this.props;
    const { initiativesHidden } = this.state;
    const { stakeholderFields } = project;
    const filteredByDraftStatus = (arr) =>
      arr.filter((initiative) => !initiative.draft);

    const communication = filteredByDraftStatus(
      project.communicationInitiatives
    );
    const readiness = filteredByDraftStatus(project.readinessInitiatives);
    const training = filteredByDraftStatus(project.trainingInitiatives);
    const sustainment = filteredByDraftStatus(project.sustainmentInitiatives);
    const communicationCount = communication.length;
    const readinessCount = readiness.length;
    const trainingCount = training.length;
    const sustainmentCount = sustainment.length;
    const getStakeholderFieldName = (key) => {
      return stakeholderFields.find((value) => value.nativeColumn === key).name;
    };
    const renderSupportColors = (key) => {
      return (
        <span key={key}>
          {RATINGS.SUPPORT_LEVELS.includes(key) ? (
            <RatingLabel className="m-l-6" rating={key} />
          ) : (
            '—'
          )}
        </span>
      );
    };

    const renderEngageColors = (key) => {
      return (
        <span key={key}>
          {RATINGS.FREQUENCY_LEVELS.includes(key) ? (
            <RatingLabel className="m-l-6" rating={key} />
          ) : (
            '—'
          )}
        </span>
      );
    };
    return (
      <React.Fragment>
        <tr>
          <td colSpan={3} width="40%">
            <div className="flex">
              <div className="flex header-item">
                <span className="text-muted m-r-12 text-nowrap">
                  {getOrgTermsContent('project')}:&nbsp;
                </span>
                <ProjectLink projectId={project.id}>{project.name}</ProjectLink>
              </div>
              <VerticalSeparator />
              <div className="flex header-item">
                <span className="text-muted m-r-12 text-nowrap">
                  {getOrgTermsContent('portfolio')}:&nbsp;
                </span>
                {project.portfolioId ? (
                  project.portfolioPermissions.canRead ? (
                    <PortfolioInfoLink portfolioId={project.portfolioId}>
                      {project.portfolioName}
                    </PortfolioInfoLink>
                  ) : (
                    <strong>{project.portfolioName}</strong>
                  )
                ) : (
                  '—'
                )}
              </div>

              {hasParentPortfolios ? (
                <React.Fragment>
                  <VerticalSeparator />
                  <div className="flex header-item">
                    <span className="text-muted m-r-12 text-nowrap">
                      {getOrgTermsContent('parentPortfolio')}:&nbsp;
                    </span>
                    <span>{project.parentPortfolioName || '—'}</span>
                  </div>
                </React.Fragment>
              ) : null}
            </div>
            <InitiativeCounts
              onClick={this.toggleInitiatives}
              initiativesHidden={initiativesHidden}
              communicationCount={communicationCount}
              readinessCount={readinessCount}
              trainingCount={trainingCount}
              sustainmentCount={sustainmentCount}
            />
          </td>
          {participantType === 'Stakeholder' && (
            <React.Fragment>
              <td style={{ minWidth: '190px' }}>
                {renderSupportColors(
                  project.support,
                  getStakeholderFieldName('support')
                )}
              </td>
              <td style={{ minWidth: '190px' }}>
                {renderEngageColors(
                  project.engagementFrequency,
                  getStakeholderFieldName('engagement_frequency')
                )}
              </td>
            </React.Fragment>
          )}
          {participantType !== 'Stakeholder' && (
            <td
              // style={{ minWidth: '140px' }}
              width="20%"
            >
              <ProjectCompletion
                initiatives={[...readiness, ...training, ...sustainment]}
              />
            </td>
          )}

          <td
            // style={{ minWidth: '180px' }}
            width="20%"
          >
            {project.owners.map((owner) => (
              <strong
                key={owner.id}
                className={`${owner.archived ? 'text-muted' : ''}`}
              >
                {owner.fullName}
                <br />
              </strong>
            ))}
          </td>
          <td width="20%">
            <strong>
              <DateRange
                startDate={project.startDate}
                endDate={project.endDate}
              />
            </strong>
          </td>
        </tr>
        <InitiativeRows
          hidden={initiativesHidden}
          initiatives={communication}
          participantType={participantType}
        />
        <InitiativeRows
          hidden={initiativesHidden}
          initiatives={readiness}
          participantType={participantType}
        />
        <InitiativeRows
          hidden={initiativesHidden}
          initiatives={training}
          participantType={participantType}
        />
        <InitiativeRows
          hidden={initiativesHidden}
          initiatives={sustainment}
          participantType={participantType}
        />
      </React.Fragment>
    );
  }
}

export default ProjectRow;
